module.exports = __webpack_public_path__ + "9edc7cba487d258abae3bf344e53aa9c.svg";